export default __webpack_public_path__ + "static/media/Machinery Red v3.90212665.png";